import RuleMapper from './ruleMapper';

const RuleFormatter = {

  formatRule(rule) {
    let ruleText = "";
    if (!rule) {
      return ruleText;
    }
    if (this.isNestedRule(rule)) {
      ruleText = this.formatGroupToString(rule);
    } else {
      ruleText = this.formatRuleToString(rule);
    }
    return ruleText;
  },

  isNestedRule(rule) {
    return rule.operator === "And" || rule.operator === "Or";
  },

  formatGroupToString(rule) {
    var children = "";
    if (rule.rules) {
      children = this.mapQueryChildren(rule.rules);
    }
    return `${rule.operator} <br/> ${children}`;
  },

  mapQueryChildren(rules) {
    var childrenText = "";
    rules.forEach((rule) => {
      childrenText += " " + this.formatRule(rule);
    });
    return childrenText;
  },

  formatRuleToString(rule) {
    const operator = RuleMapper.getQueryBuilderRuleOperator(rule);
    const value = RuleMapper.getQueryBuilderRuleTarget(rule);
    return `${rule.member_name} ${operator} ${value} <br/>`;
  }
};

export default RuleFormatter;



// WEBPACK FOOTER //
// ./src/services/utilities/ruleFormatter.js